module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/sym1.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "chapter05"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You were seen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Elder Roeder glared at me accusingly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Pardon me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You were seen. You and Nicklaus Morff. Putting your baby into the basket of the foundling home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yes—and why not? Is there a reason why a charitable act such as saving a child’s life should be kept hidden?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You make your sin worse by adding effrontery to it!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("His voice had risen, he was shrill. Others in the congregation were listening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It was the hour when believers gathered for the public chastising of sinners, when the elders denounced transgressions and the worst of those who broke church law were excluded permanently from the community.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My father stepped forward from among the group. “If my daughter is at fault in any way, I will correct her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("The elder now glared at father. “It is the Consistory that corrects!” He turned once again to me, and looked me up and down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Young girls hide evil beneath their skirts,” he said with contempt. “Do you deny that you and Nicklaus Morff placed an infant in the basket of the foundling home?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I deny nothing. We saved a baby and gave it to the nuns to prevent it from dying. We acted charitably.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Charitably! You acted wickedly! You committed fornication, and produced a bastard, then made your sin worse by hiding the proof of your wickedness among the sisters to raise according to their abominable rites!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“But that is not true!” I cried out. “Nicklaus!” I looked around me, at the faces of the congregants, hoping to see Nicklaus. But he was not there, nor was his father, or anyone else I recognized from the Morff household.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Where is Nicklaus?” I asked. “He will join me in saying what really happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Nicklaus Morff is a brawler and a liar who sins nightly in the public gardens.” I saw, to my dismay, that a number of people were nodding in agreement at the elder’s words. A murmuring had begun. A hostile murmuring. My heart sank.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Elder Roeder was unfolding a piece of writing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“The congregation is informed,” he read, “that the sinner Letitia Knollys was seen holding trysts with Nicklaus Morff and other young men at night, near the Old Bridge. That she has often left her bed at midnight to join her lover. And that on the night of the full moon she was seen going under the bridge, and her lover with her, and some time later they came out from under the bridge with a newborn child.” At these words a gasp went up from those standing nearest me, and I felt my cheeks grow hot. "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("There had been a full moon on the night the Anabaptist woman was killed, I remembered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“But there was no sin!” I burst out. “It was an act of mercy!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“How the wicked deceive themselves,” I heard someone in the congregation mutter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“The baby was the son of Anabaptists,” I went on, but as soon as I said the word “Anabaptists,” there were cries of horror.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Elder Roeder glared at me once again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You admit, then, that in addition to fornication you are guilty of consorting with the worst of sinners, those who preach error and turn the faithful from the true path!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I saw then that it was hopeless. I stood condemned unheard, no one believed or trusted me except Nicklaus, who knew the truth, and he was nowhere to be seen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Summoning all my courage, and remembering, as I did in times of distress, that I had royal blood in my veins, I stood as tall as I could (Elder Roeder being much taller) and shouted in my loudest voice, “Who is the informer that accuses me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The room fell silent. The elder folded the paper he held, and put it back into a pocket of his robe. Then, looking out across the sea of faces, he said, “Stand forth!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There was a rustling of skirts and a shuffling of feet. From the back of the room a young woman came through the crowd. At first I could see only her cap, but as she came closer I was able to see her face and realized who it was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Cecelia Knollys, do you swear that the words you have written and delivered to this congregation are truthful?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She did not look at me, or at our father, or indeed at anyone but the stern-faced elder. Before I could accuse her of lying, or "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("spit out the vengeful words that rose to my throat, the Consistory pronounced its judgment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I was banned from the congregation, and not only I, but our entire family. We were ordered to leave the Morff house, and the town of Frankfurt, by sunset on the following day, or face the wrath of the congregation and its implacable God.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b80db280","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter05.vue
// module id = 87
// module chunks = 0